import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserQuery } from 'src/app/core/user/user.query';
import { VoucherHistory } from 'src/app/core/models/VoucherHistory';
import { VoucherStatusFlag } from 'src/app/core/enums/StatusFlag';
import { VoucherCardType } from 'src/app/core/enums/CardType';
import { RewardService } from 'src/app/account/services/reward.service';
import { Location } from '@angular/common';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-reward-history',
  templateUrl: './reward-history.component.html',
  styleUrls: ['./reward-history.component.scss']
})
export class RewardHistoryComponent implements OnInit, OnDestroy {
  userLoggedIn$: Subscription;
  isLoggedIn: boolean = false;
  isOnLoad: boolean = false;
  isOnListLoad: boolean = false;
  isMaxLoad: boolean = false;
  histories: VoucherHistory[] = [];
  searchText: string = '';
  searchedText: string = '';
  skip: number = 0;
  take: number = 10;
  voucherStatus: string = '';
  cardType: VoucherCardType;
  cardTypes: any = VoucherCardType;
  voucherStatusFlag = VoucherStatusFlag;

  constructor(
    private userQuery: UserQuery,
    private rewardService: RewardService,
    private location: Location,
    private navigationService: NavigationService
  ) { }

  async ngOnInit() {
    this.userLoggedIn$ = this.userQuery.isLoggedIn$.subscribe(userData => {
      this.isLoggedIn = userData ? true : true;
    });

    if(!this.isLoggedIn){
      this.navigationService.navigate(["reward"]);
    }else {
      this.isOnLoad = true;
      await this.getHistory(this.skip, this.searchText, this.voucherStatus);
      this.isOnLoad = false;
    };
  }

  async getHistory(skip: number, searchText?: string, voucherStatus?: string) {
    let histories: VoucherHistory[] = [];

    histories = <VoucherHistory[]>await this.rewardService.getCustomerVoucherHistory(skip, this.take, searchText, voucherStatus ? voucherStatus : '');
    histories.forEach((history: VoucherHistory) => this.histories.push(history));

    this.skip = skip + histories.length;
    this.isMaxLoad = histories && histories.length === this.take ? false : true;
  }

  async onMenuChange(voucherStatus?: VoucherStatusFlag) {
    this.voucherStatus = voucherStatus ? voucherStatus : '';
    this.searchText = '';
    this.searchedText = '';
    this.skip = 0;
    this.histories = [];

    this.isOnLoad = true;
    await this.getHistory(this.skip, this.searchText, this.voucherStatus);
    this.isOnLoad = false;
  }

  onBack() {
     this.navigationService.navigate(["reward", "my-voucher"]);
  }

  checkCardType(statusFlag: string) {
    let cardType: VoucherCardType;

    switch (statusFlag) {
      case this.voucherStatusFlag.Used:
        cardType = this.cardTypes.used;
        break;
      case this.voucherStatusFlag.Expired:
        cardType = this.cardTypes.expired;
        break;
      default:
        cardType = this.cardTypes.none;
    }

    return cardType;
  }

  onClickExplore(){
    this.navigationService.navigate(["reward", "my-voucher"]);
  }

  @HostListener('window:scroll')
  async onWindowScroll() {
    // Pagination
    if (!this.isOnListLoad && !this.isMaxLoad && this.histories.length > 0) {
      if (Math.ceil(window.innerHeight + window.scrollY) >= (document.body.scrollHeight)) {
        this.isOnListLoad = true;
        await this.getHistory(this.skip, this.searchText, this.voucherStatus);
        this.isOnListLoad = false;
      }
    }
  }

  ngOnDestroy() {
    this.userLoggedIn$.unsubscribe();
  }
}
